export default "__VITE_ASSET__4174fe67__"